import { render, staticRenderFns } from "./FeedbackReportDetail.vue?vue&type=template&id=22403b7a&scoped=true"
import script from "./FeedbackReportDetail.vue?vue&type=script&lang=ts"
export * from "./FeedbackReportDetail.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackReportDetail.vue?vue&type=style&index=0&id=22403b7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22403b7a",
  null
  
)

export default component.exports